export const MAIN_PRODUCTION_HOST = 'app.venus.io';
